<template>
  <pt-video-review class="pt-video-review__withData"></pt-video-review>
</template>

<script>
import PtVideoReview from './index'
export default {
  name: 'pt-video-review__withData',
  components: {
    'pt-video-review': PtVideoReview
  }
}
</script>
